import { CpsField } from '@cs-cms/types';
import { UseQueryResult, useQuery } from '@tanstack/react-query';
import { useContext } from 'react';
import ServicesContext from '../../contexts/ServicesContext';
import { fieldsKeys } from '../../queryKeys/fields';

export function useGetAllFields(locale?: string, indexId?: number): UseQueryResult<CpsField[], unknown> {
  const servicesCtx = useContext(ServicesContext);

  const getAllFields = () => {
    if (servicesCtx?.fieldsService) {
      return servicesCtx.fieldsService.getAllFields(locale, indexId);
    }
    throw new Error('Services context not initialized');
  };

  return useQuery({
    queryKey: fieldsKeys.fieldsByLocale(locale, indexId),
    queryFn: getAllFields,
    retry: 0,
    staleTime: 1800000,
    gcTime: 1800000
  });
}
